import { Component, Inject, Prop, Vue, Watch } from 'vue-property-decorator';
import DiscoveryAndReportService from '@/service/discoveryAndReport.service';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import type { DiscoveryInfo, IResourceModel } from '@/shared/model/briefing-widget.model';
import { active } from 'd3';
import vueCustomScrollbar from 'vue-custom-scrollbar';
import { articleDetailInit } from '@/entities/article-detail/article-detail.component';
import { formatDateAgo } from '../../../util/date-util';
import moment from 'moment';
import referenceComponent from '@/entities/report-insights/template-report/template-one/reference-component';
import bodyComponent from '@/entities/report-insights/template-report/template-one/body-component';
import { groupByComponentName } from '@/entities/report-insights/report-common';
import { checkIsDocFileByUrl, getHostName, getLinkEmbedYoutube } from '@/util/ds-util';
import { namespace } from 'vuex-class';
import BriefingService from '@/service/briefing.service';
import ReferenceCardComponent from '@/shared/cards/references/reference-card.vue';
import { REFERENCE_STYLE_FOR } from '@/constants';

const appStoreState = namespace('appStore');
const briefingStore = namespace('briefingStore');

export interface responseReference {
  _id: string;
  source_uri: string;
  source_uri_domain: string;
  title: string;
  source_summary: string;
  _ml_summary: string;
  _ml_keyword: string;
  content: string;
  writer: string;
  published_at: string;
  service_language: string;
  image_uri: string[];
  image_uri_thumbnail: string;
  video_uri: string;
  favicon_uri: string;
  source_hashtag: string[];
  like_count: number;
  source_id: string;
  source_comment_id: string;
  source_reply_id: string;
  service_html: string;
  createdAt: string;
  docInfos: {
    docId: string;
    title: string;
    url: string;
  }[];
  img: string;
  inputDocInfos: string[];
  isScrap: boolean;
  mainTarget: {
    type: string;
    name: string;
    wikipediaUrl: string;
  }[];
  reportId: string;
  reportType: string;
  resourceType: string;
  bpId: string;
  userKey: string;
}

export interface IReference {
  parentDocId: string;
  data: responseReference;
}

@Component({
  computed: {
    REFERENCE_STYLE_FOR() {
      return REFERENCE_STYLE_FOR;
    },
    moment() {
      return moment;
    },
  },
  methods: { checkIsDocFileByUrl, getLinkEmbedYoutube, getHostName, formatDateAgo, active },
  components: {
    'reference-component': referenceComponent,
    'body-component': bodyComponent,
    Swiper,
    SwiperSlide,
    vueCustomScrollbar,
    'reference-card-component': ReferenceCardComponent,
  },
})
export default class reportReferent extends Vue {
  @Prop() readonly items: any[] | [];
  @Prop() readonly relatedReference: any[] | [];
  @Prop() readonly headingSelected: any | '';
  @Prop({ default: true }) readonly showEditReference!: boolean;

  @Inject('briefingService')
  private briefingService: () => BriefingService;

  data() {
    return {
      swiperOptions: {
        slidesPerView: 2.5,
        spaceBetween: 10,
        slidesOffsetBefore: 32, //첫 슬라이드 여백
        slidesOffsetAfter: 32, //마지막 슬라이드 여백
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: true,
        },
        breakpoints: {
          1400: {
            slidesPerView: 3.5,
          },
        },
      },
    };
  }

  @briefingStore.Getter
  public getSelectedResource!: IResourceModel;

  @appStoreState.Mutation
  public setIsShowReportSettingReportType!: (payload?: boolean) => void;

  @briefingStore.Getter
  public getStoreReferenceDocumentsForReport!: Array<any>;

  @briefingStore.Mutation
  public setStoreReferenceDocumentsForReport!: (payload: any) => void;

  @appStoreState.Mutation
  public setShowDetailReport!: (b: boolean) => void;

  scrollSettings = {
    wheelPropagation: false,
  };
  startIndex = 0;
  numberItemPerPage = 6;
  endIndex = this.startIndex + this.numberItemPerPage;
  referentItems: any[] = [];

  @Inject('discoveryService')
  public discoveryService: () => DiscoveryAndReportService;
  reportDetail: DiscoveryInfo = articleDetailInit;
  dataBody = [];
  isLoading = false;
  userKey = JSON.parse(localStorage.getItem('localStorageUser'))?.id || '';
  isAllowOpenPopup = false;
  originReferenceItems = [];
  deletedReferentItemIds = [];
  isReadingMode = true;
  iFrameKey = new Date().getTime().toString();
  isSuccessIframeDoc = false;
  timeOutChangeIFrameKey = 2000;
  timeOutStopChangeIFrameKey = 7000;
  timerChangeIFrameKey;
  intervalChangeIFrameKey;

  @appStoreState.Getter
  public getIsShowEditReportRef!: boolean;

  @appStoreState.Mutation
  public setShowEditReportRef!: (newVal: boolean) => void;

  isPopoverVisible = false;

  @Watch('items')
  getItem() {
    this.handleGetData();
  }

  @Watch('headingSelected')
  onHeadingSeletedChanged() {
    this.handleGetData();
  }

  public get userIdentity(): any {
    return this.$store.getters?.account
      ? this.$store.getters?.account
      : this.$store.getters?.userIdentity
      ? this.$store.getters?.userIdentity
      : JSON.parse(localStorage.getItem('localStorageUser'))
      ? JSON.parse(localStorage.getItem('localStorageUser'))
      : null;
  }

  mounted() {
    if (!this.userKey) {
      this.userKey = this.userIdentity?.id || JSON.parse(localStorage.getItem('localStorageUser'))?.id || '';
    }
    this.handleGetData();
    this.isAllowOpenPopup = false;
    this.originReferenceItems = [];
    this.deletedReferentItemIds = [];
    // this.isReadingMode = localStorage.getItem('reading-mode') == 'true';
    // this.addDefaultReadingMode();
  }

  // @Watch('isReadingMode')
  // onIsReadingModeChange() {
  //   localStorage.setItem('reading-mode', this.isReadingMode + '');
  // }

  // ifUsernoteOrFacebook() {
  //   return (
  //     this.reportDetail?.typeData.toString() === '[USERNOTE]' ||
  //     this.reportDetail?.id.toLowerCase().indexOf('facebook') > -1 ||
  //     this.reportDetail?.sourceUri.indexOf('.facebook.com') > -1
  //   );
  // }

  @Watch('getStoreReferenceDocumentsForReport')
  onGetStoreReferenceDocumentsForReportChange() {
    if (this.getStoreReferenceDocumentsForReport && this.getStoreReferenceDocumentsForReport.length > 0) {
      this.clearHeading();

      this.$nextTick(() => {
        setTimeout(() => {
          this.referentItems = this.getStoreReferenceDocumentsForReport;

          const tempCheck = this.checkIfCanSaveReferenceDocuments();
          this.isAllowOpenPopup = tempCheck;
          this.isPopoverVisible = tempCheck;

          this.$emit('handleIsEditedReferenceDocuments', this.isAllowOpenPopup);

          this.handleCheckDeletedReferenceIds();
        }, 50);
      });
    }
  }

  handleGetData() {
    this.isLoading = false;
    if (this.items.length > 0) {
      // console.log('call for items');
      const parentDocIds: any[] = this.items;
      this.discoveryService()
        .getRelatedReferent(parentDocIds)
        .then(res => {
          this.referentItems = res?.data?.body;

          if (!this.originReferenceItems || this.originReferenceItems?.length === 0) {
            // console.log(1);
            this.originReferenceItems = res?.data?.body;
          }

          if (this.getStoreReferenceDocumentsForReport?.length > 0 && this.checkIsGetAllReference() === true && !this.headingSelected) {
            this.referentItems = this.getStoreReferenceDocumentsForReport;
          } else {
            this.referentItems = res?.data?.body.filter(item => !this.deletedReferentItemIds?.includes(item?.data._id));
          }

          this.startIndex = 0;
          this.endIndex = this.numberItemPerPage;
          // this.handleGetDataFromId(res.data.body[0]?.data?._id);

          const tempId =
            this.referentItems?.[0]?.data?._id ||
            this.referentItems?.[0]?.id ||
            this.referentItems?.[0]?.data.parentDocId ||
            this.referentItems?.[0]?.data.parent_doc_id[0] ||
            this.referentItems?.[0]?.data.docId ||
            res.data.body[0]?.data?._id ||
            undefined;

          if (tempId) {
            this.handleGetDataFromId(tempId, this.referentItems?.[0] || undefined);
          }
        });
    } else {
      // console.log('call for relatedReference');
      const parentDocIds: any[] = this.relatedReference;
      this.discoveryService()
        .getRelatedReferent(parentDocIds)
        .then(res => {
          this.referentItems = res?.data?.body;

          if (!this.originReferenceItems || this.originReferenceItems?.length === 0) {
            this.originReferenceItems = res?.data?.body;
          }

          // console.log('this.referentItems: ', this.referentItems);
          // console.log('this.originReferenceItems: ', this.originReferenceItems);
          // console.log('compare: ', this.checkIsGetAllReference());

          if (this.getStoreReferenceDocumentsForReport?.length > 0 && this.checkIsGetAllReference() === true && !this.headingSelected) {
            this.referentItems = this.getStoreReferenceDocumentsForReport;
          } else {
            this.referentItems = res?.data?.body.filter(item => !this.deletedReferentItemIds?.includes(item?.data._id));
          }

          this.startIndex = 0;
          this.endIndex = this.numberItemPerPage;
          // this.handleGetDataFromId(res.data.body[0]?.data?._id);

          const tempId =
            this.referentItems?.[0]?.data?._id ||
            this.referentItems?.[0]?.id ||
            this.referentItems?.[0]?.data.parentDocId ||
            this.referentItems?.[0]?.data.parent_doc_id[0] ||
            this.referentItems?.[0]?.data.docId ||
            res.data.body[0]?.data?._id ||
            undefined;

          if (tempId) {
            this.handleGetDataFromId(tempId, this.referentItems?.[0] || undefined);
          }
        });
    }
    // else {
    //   // this.referentItems = [];
    //   this.reportDetail = articleDetailInit;
    // }
    this.isLoading = true;
  }

  handleGetDataFromId(id, itemInput?: any) {
    // console.log('id: ', id);
    // console.log('itemInput: ', itemInput);

    if (id?.trim()?.length === 0 || id?.includes('doc')) {
      this.isSuccessIframeDoc = false;
      // console.log('itemInput: ', itemInput);

      let tempUrl = itemInput?.data.sourceUri
        ? itemInput.data?.sourceUri?.startsWith('/')
          ? window?.location?.origin + '/' + itemInput.data?.sourceUri?.replace(/^\/opt\/deepsignal\//, '')
          : itemInput.data?.sourceUri
        : itemInput.data?.source_uri
        ? itemInput.data?.source_uri.startsWith('/')
          ? window?.location?.origin + '/' + itemInput.data?.source_uri?.replace(/^\/opt\/deepsignal\//, '')
          : itemInput.data?.source_uri
        : itemInput.data?.path
        ? itemInput.data?.path.startsWith('/')
          ? window?.location?.origin + '/' + itemInput.data?.path?.replace(/^\/opt\/deepsignal\//, '')
          : itemInput.data?.path
        : '';

      if (tempUrl?.trim()?.length > 0 && !tempUrl?.includes('http')) {
        tempUrl = 'https://dzh91b51qfr7r.cloudfront.net/upload/'.concat(tempUrl);
      }

      const temp = {
        content: itemInput.data?.content || '',
        id: itemInput.data?.id || itemInput.data?._id || id || '',
        sourceUri: tempUrl || '',
        serviceHtml: itemInput.data?.serviceHtml || '',
        title: itemInput.data?.title || '',
        writer: itemInput.data?.writer || '',
        publishedAt: itemInput.data?.publishedAt || itemInput.data?.published_at || '',
        objectReport: itemInput.data?.objectReport || '',
        typeData: 'FILE',
      };

      this.reportDetail = temp;

      this.isReadingMode = false;

      this.onIframeLoad();

      return;
    }

    this.isLoading = false;
    $('#preview-referent').animate({ scrollTop: 0 }, 'fast');
    this.discoveryService()
      .getDetailService(id)
      .then(async res => {
        if (res?.data) {
          const temp = {
            content: res.data?.content || '',
            id: res.data?.id || '',
            sourceUri: res.data?.sourceUri.startsWith('/')
              ? window.location.origin + '/' + res.data?.sourceUri.replace(/^\/opt\/deepsignal\//, '')
              : res.data?.sourceUri || '',
            serviceHtml: res.data?.serviceHtml || '',
            title: res.data?.title || '',
            writer: res.data?.writer || '',
            publishedAt: res.data?.publishedAt || '',
            objectReport: res.data?.objectReport || '',
            typeData: res.data?.typeData || '',
          };
          if (id.includes('report')) {
            this.reportDetail = temp;
            const newObj = groupByComponentName(res.data.objectReport?.components);
            this.dataBody = newObj?.body_component;
          } else {
            this.reportDetail = temp;
          }

          if (
            temp?.typeData !== undefined &&
            temp?.typeData !== null &&
            temp?.typeData?.toString()?.trim()?.length > 0 &&
            temp?.typeData?.toString() === '[USERNOTE]'
          ) {
            this.isReadingMode = true;
            this.isLoading = true;
            return;
          }

          await this.briefingService()
            .checkIframeAllowed(this.reportDetail.sourceUri)
            .then(res => {
              // console.log('checkIframeAllowed', res.data);
              const xFrameOptions = res?.data['X-Frame-Options'];
              const contentSecurityPolicy = res?.data['Content-Security-Policy'];

              if (this.checkIframeAllowedInHeader(xFrameOptions?.toLowerCase(), contentSecurityPolicy?.toLowerCase())) {
                this.isReadingMode = false;
              } else {
                this.isReadingMode = true;
              }
            });
        }
      });
    this.isLoading = true;
  }

  handleOpenModel() {
    if (
      !this.getSelectedResource ||
      !this.getSelectedResource?.owner_user_key ||
      this.getSelectedResource?.owner_user_key === undefined ||
      !this.userKey ||
      this.userKey === '' ||
      this.userKey !== this.getSelectedResource?.owner_user_key
    ) {
      return;
    }

    this.setShowEditReportRef(true);
  }

  selectComponent(component: string, arrDocId) {
    this.$emit('selectComponent', arrDocId);
  }

  prevSlide() {
    if (this.startIndex > 0 && this.referentItems !== null) {
      this.startIndex = this.startIndex - 6 < 0 ? 0 : this.startIndex - 6;
      this.endIndex = this.startIndex + this.numberItemPerPage;
    }
  }

  nextSlide() {
    if (this.referentItems !== null && this.endIndex < this.referentItems.length + 1) {
      this.endIndex = this.endIndex + 6 > this.referentItems.length + 1 ? this.referentItems.length : this.endIndex + 6;
      this.startIndex = this.endIndex - this.numberItemPerPage;
    }
  }

  formattedDate(inputDateString) {
    if (inputDateString.length > 0 && inputDateString) {
      const year = inputDateString.substring(0, 4);
      const month = inputDateString.substring(4, 6);
      const day = inputDateString.substring(6, 8);
      return `${year}-${month}-${day}`;
    }
  }

  newWidowOrigin(link) {
    window.open(link);
  }

  uniqueWriters() {
    const seen = new Set();
    if (!Array.isArray(this.reportDetail.writers)) {
      seen.add(getHostName(this.reportDetail?.sourceUri));
      return Array.from(seen || '');
    } else {
      this.reportDetail?.writers?.filter(writer => {
        const writerString = writer.toString();
        if (writer.startsWith('https')) {
          seen.add(getHostName(writerString));
        } else {
          seen.add(writerString);
        }
      });
      return Array.from(seen);
    }
  }

  clearHeading() {
    this.$emit('headingSelected', '');
    this.$emit('items', []);
  }

  handleOpenPopupReportSettingReportTypeModal() {
    this.setIsShowReportSettingReportType(true);
  }

  checkIfCanSaveReferenceDocuments(): boolean {
    if (!this.referentItems || !this.originReferenceItems) {
      return false;
    }

    if (this.referentItems?.length < 1) {
      return false;
    }

    // Check if the lengths are different
    if (this.referentItems.length !== this.originReferenceItems.length) {
      return true;
    }

    // Create arrays of IDs for comparison
    const modifyIdsList = this.referentItems.map(item => item?.data?._id || item?.id || item?.docId);
    const originIdsList = this.originReferenceItems.map(item => item?.data?._id || item?.id || item?.docId);

    // Check for any modifications in IDs
    const hasModifiedItems = modifyIdsList.some(id => !originIdsList.includes(id));

    return hasModifiedItems;
  }

  checkIsGetAllReference(): boolean {
    if (!this.referentItems || !this.originReferenceItems || this.headingSelected) {
      return false;
    }

    if (this.referentItems?.length === 0 || this.originReferenceItems?.length === 0) {
      return false;
    }

    if (this.referentItems.length !== this.originReferenceItems.length) {
      return false;
    }

    // Create arrays of IDs for comparison
    const modifyIdsList = this.referentItems?.map(item => item?.data?._id || item?.id || item?.docId);
    const originIdsList = this.originReferenceItems?.map(item => item?.data?._id || item?.id || item?.docId);

    // Check if all IDs in modifyIdsList are present in originIdsList
    const allIdsMatch = modifyIdsList?.every(id => originIdsList?.includes(id));

    return allIdsMatch;
  }

  handleCheckDeletedReferenceIds() {
    const originIdsList = this.originReferenceItems?.map(item => item?.data?._id || item?.id || item?.docId) || [];
    const modifyIdsList = this.getStoreReferenceDocumentsForReport?.map(item => item?.data?._id || item?.id || item?.docId) || [];

    // Find IDs in originIdsList that are not in modifyIdsList
    this.deletedReferentItemIds = originIdsList?.filter(id => !modifyIdsList?.includes(id));
  }

  addDefaultReadingMode() {
    localStorage.setItem('reading-mode', 'false');
  }

  checkIframeAllowedInHeader(xFrameOptions, contentSecurityPolicy) {
    if (xFrameOptions && (xFrameOptions === 'deny' || xFrameOptions.includes('sameorigin'))) {
      return false;
    }

    if (contentSecurityPolicy && contentSecurityPolicy.includes('frame-ancestors')) {
      return false;
    }

    return true;
  }

  onIframeLoad(isSuccess?: boolean) {
    // console.log('isSuccess: ', isSuccess);
    this.clearTimerChangeIFrameKey();

    if (isSuccess !== undefined && isSuccess === true) {
      this.isSuccessIframeDoc = true;

      this.clearTimerChangeIFrameKey();
    } else {
      this.isSuccessIframeDoc = false;

      this.timerChangeIFrameKey = setTimeout(() => {
        this.changeIframeKey();
      }, this.timeOutChangeIFrameKey);
    }
  }

  clearTimerChangeIFrameKey() {
    clearTimeout(this.timerChangeIFrameKey);
    this.timerChangeIFrameKey = null;
  }

  changeIframeKey() {
    // console.log('changeIframeKey');
    let countTimes = 0;

    this.clearInterValChangeIFrameKey();

    this.intervalChangeIFrameKey = setInterval(() => {
      if (countTimes < 4) {
        // console.log('this.isSuccessIframeDoc: ', this.isSuccessIframeDoc);
        if (!this.isSuccessIframeDoc) {
          this.iFrameKey = new Date().getTime().toString();
        } else {
          this.clearInterValChangeIFrameKey();
        }
        countTimes++;
      }
    }, this.timeOutChangeIFrameKey);

    setTimeout(() => {
      this.clearInterValChangeIFrameKey();
    }, this.timeOutStopChangeIFrameKey);
  }

  clearInterValChangeIFrameKey() {
    clearInterval(this.intervalChangeIFrameKey);
    this.intervalChangeIFrameKey = null;
  }

  onIframeError() {
    this.changeIframeKey();
  }

  doNothing() {}

  handleClosePopover() {
    this.isPopoverVisible = false;
  }
}
